import React from 'react';
import { useLocation } from 'react-router-dom';
import './App.scss';
// import Header from './ui/components/Header';
import AppRoutes from './Routes';

const App = (props) => {
  const location = useLocation();
  return (
    <div className="App">
      <AppRoutes />
    </div>
  );
}

export default App;
